import type { Locale } from './locale'

export type PilotToolPath =
  | '/json-formatter'
  | '/json-minifier'
  | '/yaml-formatter'
  | '/xml-formatter'

export const PILOT_EN_PATHS: Readonly<Record<PilotToolPath, `/en${PilotToolPath}`>> = {
  '/json-formatter': '/en/json-formatter',
  '/json-minifier': '/en/json-minifier',
  '/yaml-formatter': '/en/yaml-formatter',
  '/xml-formatter': '/en/xml-formatter',
}

const PILOT_RU_PATHS = Object.keys(PILOT_EN_PATHS) as PilotToolPath[]
const PILOT_RU_BY_EN = new Map<string, PilotToolPath>(
  Object.entries(PILOT_EN_PATHS).map(([ru, en]) => [en, ru as PilotToolPath]),
)

export function resolvePilotPathLocale(pathname: string): Locale | null {
  if (PILOT_RU_PATHS.includes(pathname as PilotToolPath)) return 'ru'
  if (PILOT_RU_BY_EN.has(pathname)) return 'en'
  return null
}

export function resolvePilotFirstPathLocale(
  pathname: string,
  resolveFallback: (pathname: string) => Locale | null,
): Locale | null {
  return resolvePilotPathLocale(pathname) ?? resolveFallback(pathname)
}

export function localizedPilotPath(pathname: string, locale: Locale): string | null {
  const ruPath = PILOT_RU_BY_EN.get(pathname)
    ?? (PILOT_RU_PATHS.includes(pathname as PilotToolPath)
      ? pathname as PilotToolPath
      : null)
  if (!ruPath) return null
  return locale === 'en' ? PILOT_EN_PATHS[ruPath] : ruPath
}

export function pilotAnalyticsDimensions(pathname: string, locale: Locale) {
  const landingLocale = resolvePilotPathLocale(pathname)
  if (!landingLocale) {
    throw new Error(`Pilot analytics require a paired utility path: ${pathname}`)
  }
  return {
    locale,
    landing_locale: landingLocale,
    route: pathname,
    processing: 'local' as const,
  }
}
